<template>
  <v-app standalone :class="[$root.isRTL ? 'RLT' : '']">
    <v-navigation-drawer v-model="$root.activeSubMenu" hide-overlay light :class="[$root.device.isTablet ? 'tabletMenu' : '', $root.isRTL ? 'navigation-drawer--right' : '', 'elevation-10']" style="padding: 0px; margin: 0px; z-index: 200;">
      <SubMenu></SubMenu>
    </v-navigation-drawer>
    <v-container fluid style="z-index: 100;">
      <transition name="slide-right">
        <router-view class="child-view"></router-view>
      </transition>
    </v-container>
    <v-snackbar :timeout="$root.alert.timeout" :top="$root.alert.isTop" v-model="$root.alert.isShow">{{ $root.alert.message }}</v-snackbar>
    <PopupConfim></PopupConfim>

    <transition name="slide-right">
      <div :class="['mobileMenu', $root.activeMobileMenu ? 'activeMenu' : '']">
        <SubMenu></SubMenu>
      </div>
    </transition>


  </v-app>
</template>

<script>
  import { db } from '../firebase';
  var usersRef = db.ref('Users');

  import SubMenu from '../components/SubMenu';
  import Notification from '../components/Notification';
  import PopupConfim from '../components/PopupConfim';

  import imgUser from '../assets/user.png';

  export default {
    name: 'Layout',
    components: {
      SubMenu,
      user: null,
      Notification,
      PopupConfim,
      messages: [],
    },
    data() {
      return {
      }
    },
    created() {
      this.$Log("Vue [Layout] is created ...");
    },
    ready() {
      this.$Log("Vue [Layout] is ready ...");
    },
    mounted() {
      this.$Log("Vue [Layout] is mounted ...");

      if (this.user && this.user[0] && this.user[0]['.key'] == this.$root.user['.key']) {
        this.$root.user.Active = this.user[0].Active;
        this.$root.user.Approved = this.user[0].Approved;
        this.$root.user.FullName = this.user[0].FullName;
        this.$root.user.Identity = this.user[0].Identity;
        this.$root.user.MessagesCounter = this.user[0].MessagesCounter;
        this.$root.user.Password = this.user[0].Password;
        this.$root.user.Token = this.user[0].Token;
        this.$root.user.Type = this.user[0].Type;
        this.$root.user.Username = this.user[0].Username;
      }
    },
    updated() {
      this.$Log("Vue [Layout] is updated ...");
    },
    methods: {
    }
  }

</script>

<style>
  /*.gm-style-iw {
    top: 0 !important;
    left: 0 !important;
    border-radius: 2px 2px 0 0;
  }*/

  .mobileContent {
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    z-index: 15000;
    display: block;
    background-color: transparent !important;
  }

  .mobileMenu {
    background-color: #ccc;
    background-color: #fff;
    width: 80%;
    height: 0px;
    height: 100%;
    top: 0px;
    position: absolute;
    padding: 0px;
    left: -80%;
    /*pointer-events: none;*/
    z-index: 55000;
    /*border-right: 2px solid #000;*/
    border-right: 2px solid rgb(58, 45, 1);
    /*pointer-events: all;*/
  }

  .tabletMenu {
    -webkit-transform: translate3d(0,0,0) !important;
    transform: translate3d(0,0,0) !important;
  }

  .activeMenu {
    left: 0px !important;
  }

  textarea, input[type=text], input[type=password], input[type=number], input[type=date] {
    border-bottom: 1px solid #3A2D01;
  }

  input[type=date]::-webkit-clear-button {
    display: none;
  }
  input[type=date]::-webkit-inner-spin-button {
    display: none;
  }
  input[type=date]::-webkit-calendar-picker-indicator {
    color: #2c3e50;
  }

  .RLT {
    direction: rtl;
    text-align: right;
  }

  .mainRLT {
    padding-right: 0px !important;
    position: fixed;
    /*top: 0px;
    bottom: 0px;*/
    left: 0px;
    right: 250px;
  }

  .overlay--active {
    z-index: 50000;
  }

  .dialog__content {
    z-index: 60000;
  }

  .blueRLT {
    left: -250px !important;
  }

  .thumb {
    height: 50px;
    width: 80px;
    border-radius: 10px;
  }

  .scrollContent {
    max-height: 550px;
    max-height: calc(100vh - 160px);
    min-height: calc(100vh - 160px);
    overflow-y: scroll;
  }

  .scrollContentMobile {
    max-height: 550px;
    /*max-height: calc(100vh - 110px);
    min-height: calc(100vh - 110px);*/
    max-height: calc(100vh - 200px);
    overflow-y: scroll;
  }

  .w3-check {
    width: 18px !important;
    height: 18px !important;
  }

  .sp {
    padding-right: 10px !important;
  }

  .fullContent {
    position: absolute;
    top: 0px;
    left: 250px;
    bottom: 0px;
    right: 0px;
    z-index: 15000;
    display: block;
    background-color: transparent !important;
  }

  .fullContentRTL {
    position: absolute;
    top: 0px;
    right: 250px;
    bottom: 0px;
    left: 0px;
    z-index: 15000;
    display: block;
    background-color: transparent !important;
  }
  
  .showInfo {
    display: block;
  }

  .imgMusketeer {
    width: 50px;
    height: 50px;
    border: 3px solid #CC2636;
    border-radius: 100%;
    cursor: pointer;
    position: relative;
  }

  .divMusketeerArrow {
    width: 10px;
    height: 10px;
    background-color: #CC2636;
    -ms-transform: rotate(45deg); /* IE 9 */
    -webkit-transform: rotate(45deg); /* Safari */
    transform: rotate(45deg);
    position: absolute;
    left: 32px;
    top: 44px;
  }
    
    .musketeerFont {
    font-family: "Segoe UI",Arial,sans-serif !important;
  }

  .snack--top {
    z-index: 5000000;
  }

  .txtBorder {
    font-family: 'Montserrat-Regular', 'Montserrat' !important;
    border: 0.5px solid #ccc !important;
    padding: 10px;
    width: 100%;
    color: #818181;
    overflow: hidden;
  }

  .txtBorderBottom {
    /*font-family: 'Montserrat-Regular', 'Montserrat' !important;*/
    border-bottom: 0.5px solid #ccc !important;
    padding: 10px;
    width: 100%;
    color: #818181;
  }
  
  .application {
    width: 100%;
    /*padding-left: 350px !important;*/
  }

  .applicationRLT {
    width: 100%;
    /*padding-right: 350px !important;*/
  }

  .lblTitle {
    position: fixed;
    top: 25px;
    right: 30px;
    color: #fff;
    font-size: 20px;
    z-index: 1000;
  }

  .lblTitleRLT {
    position: fixed;
    top: 25px;
    right: 400px;
    color: #fff;
    font-size: 20px;
    z-index: 1000;
  }
  
  .imgCenter {
    position: fixed;
    top: 100px;
    right: 10px;
    color: #fff;
    font-size: 20px;
    z-index: 1000;
    cursor: pointer;
    width: 40px;
    height: 40px;
  }

  .imgCenterRLT {
    position: fixed;
    top: 100px;
    left: 10px;
    color: #fff;
    font-size: 20px;
    z-index: 1000;
    cursor: pointer;
    width: 40px;
    height: 40px;
  }
  
  .iconSearch {
    opacity: 1;
    position: fixed;
    top: 30px;
    left: 610px;
    z-index: 1000;
    color: #999999;
    font-size: 20px;
  }

  .iconSearchRLT {
    opacity: 1;
    position: fixed;
    top: 30px;
    left: 60px;
    z-index: 1000;
    color: #999999;
    font-size: 20px;
  }
  
  .mapSearch {
    opacity: 1;
    position: fixed;
    top: 20px;
    left: 390px;
    z-index: 1000;
    width: 250px;
    border: 1px solid #eee;
    background-color: white;
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    color: #999999;
    font-size: 13px;
  }

  .mapSearchRTL {
    opacity: 1;
    position: fixed;
    top: 20px;
    left: 50px;
    z-index: 1000;
    width: 250px;
    border: 1px solid #eee;
    background-color: white;
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    color: #999999;
    font-size: 13px;
  }
  
  
  .logoSmall {
    width: 55px;
    height: 50px;
    margin-top: 10px;
  }
  
  main {
    padding-left: 0px !important;
    margin-top: -80px;
  }

  .mainTop0 {
    margin-top: 0px;
  }
  
  #layout {
    width: 100%;
  }

  .content {
    height: 88vh; /* 100% - 64px*/
    width: 82vw; /* 100% - 350px*/
    height: calc(100% - 64px);
    width: calc(100% - 250px);
  }

  .container {
    padding: 0px;
    padding-top: -100px;
  }

  .toolbar {
    height: 80px;
    padding: 0px;
  }

  .toolbar .toolbar__content {
    width: 100%;
  }

  .toolbar .toolbar__content .toolbar__title {
    width: 80px;
    text-align: left;
  }

  .btn--icon .btn__content .icon {
    color: white !important;
    font-size: 40px;
  }

  .navigation-drawer--close:not(.navigation--permanent).navigation-drawer--right {
    -webkit-transform: translate3d(250px,0,0);
    transform: translate3d(250px,0,0);
  }

  custom-dropdown--large {
    font-size: 1.5em;
  }

  .custom-dropdown--small {
    font-size: .7em;
  }

  .custom-dropdown__select {
    font-size: inherit; /* inherit size from .custom-dropdown */
    padding: .2em .5em .2em .5em; /* add some space*/
    margin: 0; /* remove default margins */
  }

  .custom-dropdown__select--white {
    background-color: #fff;
    color: #444;
  }

  .custom-dropdown {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    border: 1px solid rgba(0,0,0,.1);
  }

  .custom-dropdown__select {
    padding-right: 2.5em; /* accommodate with the pseudo elements for the dropdown arrow */
    border: 0;
    border-radius: 3px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  .custom-dropdown::before,
  .custom-dropdown::after {
    content: "";
    position: absolute;
    pointer-events: none;
  }

  .custom-dropdown::after { /*  Custom dropdown arrow */
    content: "\25BC";
    height: 1em;
    font-size: .625em;
    line-height: 1;
    right: 1.2em;
    top: 50%;
    margin-top: -.5em;
  }

  .custom-dropdown::before { /*  Custom dropdown arrow cover */
    width: 2em;
    right: 0;
    top: 0;
    bottom: 0;
    border-radius: 0 3px 3px 0;
  }

  .custom-dropdown__select[disabled] {
    color: rgba(0,0,0,.3);
  }

  .custom-dropdown.custom-dropdown--disabled::after {
    color: rgba(0,0,0,.1);
  }

  /* White dropdown style */
  .custom-dropdown--white::before {
    background-color: #fff;
    /*border-left: 1px solid rgba(0,0,0,.1);*/
    border-left: 1px solid rgba(0,0,0,.1);
  }

  .custom-dropdown--white::after {
    color: rgba(0,0,0,.9);
  }

  /* FF only temp fix */
  @-moz-document url-prefix() {
    .custom-dropdown__select {
      padding-right: .9em
    }

    .custom-dropdown--large .custom-dropdown__select {
      padding-right: 1.3em
    }

    .custom-dropdown--small .custom-dropdown__select {
      padding-right: .5em
    }
  }

  .fullToolbar {
    background-color: #3A2D01 !important;
    background-color: #F7941D !important;
  }

  i.btnAdd {
    color: #fff !important;
    background-color: #3A2D01 !important;
    border-radius: 50%;
    width: 30px !important;
    height: 30px !important;
    font-size: 30px;
    margin: 10px;
  }

</style>



// WEBPACK FOOTER //
// Layout.vue?406a0af5